<template>
    <rkm-table
        :fields="fields"
        :items="items"
        ref="RkmTable"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="edit(row.item)"
                authorize="update-painel-senha-prioridade"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            return [
                { key: 'nome', label: 'Nome', sortable: true },    
                { key: 'grau', label: 'Grau de prioridade', sortable: true },
                { class: 'col-min text-center', key: 'actions', label: 'Ações' },
            ]
        },
    },
    created() {
        this.repositories = {
            prioridade: this.getConectaSusRepository('painelSenha.prioridade')
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.prioridade.index()
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(item) {
            this.$router.push({ name: 'painel-senha-prioridade-edit', params: { id: item.id } })
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>